import React from 'react';
import MapMarker from '../../../../../images/map-marker.svg';
import SelectedMapMarker from '../../../../../images/map-marker-highlighted.svg';

export const PropertyMarker = ({
    lat,
    lng,
    setSelectedProperty,
    propertySelected
}: {
    lat: number;
    lng: number;
    setSelectedProperty: () => void;
    propertySelected: boolean;
}) => {
    return (
        <div className="marker">
            <img
                onClick={setSelectedProperty}
                src={propertySelected ? MapMarker : SelectedMapMarker}
                height="50rem"
                width="50rem"
                alt="map marker"
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/Marker.tsx